import React from "react";
import SurgeryQueueWidget from "./SurgeryQueueWidget";
import ProcedureHistory from "../shared/ProcedureHistory";
import "../Treatments.css";

interface Props {
    mode: "extraction" | "implant";
}

export default function SurgeryManager({ mode }: Props) {
    const title = mode === "extraction" ? "Exodontia & Surgery" : "Implantology & Surgery";
    const procedureType = mode === "extraction" ? "Extraction" : "Implant";

    return (
        <div className="mod-standalone-window" style={{ height: 'calc(100vh - 100px)', padding: '20px', display: 'flex', flexDirection: 'column' }}>
            <div className="mod-window-header" style={{ marginBottom: '20px', paddingBottom: 0, borderBottom: 'none' }}>
                <h2 style={{ display: 'flex', alignItems: 'center', gap: '8px', margin: 0 }}>
                    {mode === "extraction" ? '🦷 Exodontia & Surgery' : '🔩 Implantology & Surgery'}
                </h2>
            </div>
            
            <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(380px, 1fr))',
                gap: '20px',
                flex: 1,
                minHeight: 0
            }}>
                {/* Left Panel: Active Queue */}
                <div className="mod-card" style={{ display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                    <SurgeryQueueWidget groupByPatient onSelectPatient={() => { }} />
                </div>

                {/* Right Panel: History */}
                <div className="mod-card" style={{ display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                    <ProcedureHistory
                        procedureType={procedureType}
                        title={`${procedureType} History`}
                    />
                </div>
            </div>
        </div>
    );
}
